import { navigationRoutes } from '@app/utils/navigation-routes';

import { ApexOptions } from 'apexcharts';

import { ReportChart } from '@app/interfaces/report.type';

import { Filter, Range } from '../ui/easy-filter/types';

export type ApexPointEvent = {
  seriesIndex: number;
  dataPointIndex: number;
  w: {
    config: ApexOptions;
  };
};

export const onChartPointHandleClick = (
  pointEvent: ApexPointEvent,
  chartInfo: { data: ReportChart; currentTemplate: 'chats' | 'chat' | 'voice' },
) => {
  const { dataPointIndex, seriesIndex } = pointEvent;
  const { currentTemplate, data } = chartInfo;
  if (data.type === 'number') return;
  const filterParams: Filter & Range = {
    range: {
      type: 'n',
      parameters: [],
    },
    filter: [],
  };
  const seriesMetrics = data?.series[seriesIndex]?.metric_id;
  const seriesAggregate = data?.series[seriesIndex]?.aggregate;
  // const seriesMetrics = data.series.map((data) => data.name);
  const chartGroupType = data?.group?.type;
  // const currentSeriesPoint = data.series[seriesIndex].data[dataPointIndex];
  const currentCategoryPoint =
    chartGroupType === 'metric'
      ? data.categories[dataPointIndex]
      : Object.values(data.system_date_diapason?.[dataPointIndex] || {});

  switch (chartGroupType) {
    case 'date':
      filterParams.range.type = 'r';
      for (let i = 0; i < currentCategoryPoint?.length; i++) {
        if (filterParams.range.type === 'r') {
          filterParams.range?.parameters.push({
            value: currentCategoryPoint[i],
            condition: i === 0 ? '>=' : '<=',
          });
        }
      }
      break;
    case 'metric':
      filterParams.range = {
        parameters: data.range?.parameters || [],
        type: data.range?.type,
      } as any;
      filterParams.filter.push({
        id: data?.group?.metric_id || '',
        value: currentCategoryPoint,
        condition: '=',
      });
      break;
    case 'metric_reverse':
      filterParams.range = {
        parameters: data.range?.parameters || [],
        type: data.range?.type,
      } as any;
      filterParams.filter.push({
        id: data?.metrics_y?.[0]?.id || '',
        value: data.series?.[seriesIndex]?.name || '',
        condition: '=',
      });
      filterParams.filter.push({
        id: data.group?.metric_id?.[dataPointIndex] || '',
        value: '0',
        condition: '>',
      });
      break;
    default:
      break;
  }
  localStorage.setItem(
    'filterFromChart',
    JSON.stringify({
      filter: filterParams,
      series: { metric_id: seriesMetrics, aggregate: seriesAggregate },
    }),
  );

  window.open(
    `/${
      currentTemplate === 'chats' || currentTemplate === 'chat'
        ? navigationRoutes.chatReports
        : navigationRoutes.reports
    }/${data.live_report_id}/${navigationRoutes.reportRecords}`,
    '_blank',
  );
};
